// extracted by mini-css-extract-plugin
export default {"Entable":"_2-nNySlWV5ypkjgyoCKrqG"};